var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatar1X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "45px",
    viewBox: "0 0 43 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "752D3391-6E00-414A-964B-D9CDEB4ED792@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "2.43e-05 0.0064881 42.1938963 0.0064881 42.1938963 42.201 2.43e-05 42.201"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DA8F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5866F5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(-1848.000000, -99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-2",
    transform: "translate(1606.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(59.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Avatar",
    transform: "translate(183.000000, 1.558140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.074520)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2",
    opacity: 0.900000036
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0971223,42.2010081 C32.7168963,42.2010081 42.1938963,32.7236031 42.1938963,21.1038291 C42.1938963,9.4835691 32.7168963,0.0064881 21.0971223,0.0064881 C9.4774293,0.0064881 2.43e-05,9.4835691 2.43e-05,21.1038291 C2.43e-05,32.7236031 9.4774293,42.2010081 21.0971223,42.2010081",
    id: "Fill-1",
    fill: "#C4E2FC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0971142,10.2491406 C22.9589802,10.2491406 24.6458052,11.0045466 25.8655842,12.2242446 C27.0853632,13.4442666 27.8409312,15.1314156 27.8409312,16.9932816 C27.8409312,18.8549046 27.0853632,20.5411626 25.8655842,21.7615086 C25.3476994,22.2792214 24.745624,22.7134007 24.0817063,23.0416547 C25.7246732,23.4623156 27.1960123,24.2261503 28.381752,25.2335817 C30.274722,26.8420797 31.446387,29.0708757 31.446387,31.5371637 L31.438935,31.8239847 L31.438935,31.8344337 L31.424193,32.0992227 L30.355965,32.0404977 L30.370869,31.7753037 L30.373461,31.5371637 C30.373461,29.4000597 29.347515,27.4591377 27.689769,26.0507907 C26.007561,24.6217077 23.6763,23.7368637 21.097098,23.7368637 C18.518139,23.7368637 16.186716,24.6217077 14.503617,26.0507907 C12.845871,27.4591377 11.819844,29.4000597 11.819844,31.5371637 L11.823084,31.7837277 L11.823084,31.7859147 L11.837988,32.0320737 L10.769193,32.1076467 C10.763928,32.0330457 10.758582,31.9374657 10.755018,31.8260097 L10.755018,31.8239847 C10.750158,31.7007837 10.747566,31.6068237 10.747566,31.5371637 C10.747566,29.0708757 11.918664,26.8420797 13.812201,25.2335817 C14.9976483,24.226355 16.4686442,23.4626261 18.1112164,23.038997 C17.4478307,22.7131616 16.8459787,22.2791328 16.3283202,21.7615086 C15.1085412,20.5417296 14.3529732,18.8549046 14.3529732,16.9932816 C14.3529732,15.1319826 15.1085412,13.4468586 16.3283202,12.2265126 L16.3283202,12.2242446 C17.5481802,11.0038986 19.2355722,10.2491406 21.0971142,10.2491406 Z M21.0971142,11.3214996 C19.5308982,11.3214996 18.1124262,11.9564586 17.0864802,12.9824046 L17.0854272,12.9812706 C16.0605342,14.0072976 15.4255752,15.4257696 15.4255752,16.9932816 C15.4255752,18.5591736 16.0611012,19.9775646 17.0864802,21.0030246 C18.1124262,22.0289706 19.5308982,22.6639296 21.0971142,22.6639296 C22.6630062,22.6639296 24.0814782,22.0284036 25.1068572,21.0030246 C26.1328032,19.9770786 26.7680052,18.5591736 26.7680052,16.9932816 C26.7680052,15.4268226 26.1328032,14.0084316 25.1068572,12.9824046 C24.0814782,11.9570256 22.6630062,11.3214996 21.0971142,11.3214996 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1X);
export default __webpack_public_path__ + "static/media/Avatar1x.357cdb6e0a8a86a8f34523ca4d77cdcb.svg";
export { ForwardRef as ReactComponent };